import React, { useEffect, useState, useContext } from 'react';
import api from '../utils/api';
import { track } from '../utils/analytics';
import { UserContext } from '../App';

export default function UploadSignedWill() {
  const { currentUser } = useContext(UserContext);
  const [file, setFile] = useState(null);
  const [jurisdiction, setJurisdiction] = useState('ENGLAND_WALES');
  const [current, setCurrent] = useState(null);
  const [confirmInfo, setConfirmInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  const apiBase = (typeof window !== 'undefined' && window.__API_BASE_URL__) || process.env.REACT_APP_API_BASE_URL || ((typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) ? 'https://127.0.0.1:3001' : '');

  const refresh = async () => {
    const res = await api.get('/will/list');
    setCurrent(res.data.currentFile || null);
  };

  useEffect(() => { refresh(); }, []);

  const submit = async (confirmReplace=false) => {
    if (!file) return;
    try {
      setBusy(true);
      track('will_upload_started', { userId: currentUser?.id, ext: (file.name.split('.').pop()||'').toLowerCase(), size: file.size });
      const fd = new FormData();
      fd.append('file', file);
      fd.append('jurisdiction', jurisdiction);
      if (confirmReplace) fd.append('confirmReplace', 'true');
      const res = await api.post('/will/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      if (res.data.requiresConfirm) {
        setConfirmInfo(res.data.existing);
        track('will_upload_requires_confirm', { userId: currentUser?.id });
        return;
      }
      await refresh();
      track('will_upload_succeeded', { userId: currentUser?.id, ext: (file.name.split('.').pop()||'').toLowerCase(), size: file.size });
      setFile(null);
      alert('Upload successful.');
    } catch (err) {
      console.error(err);
      track('will_upload_failed', { userId: currentUser?.id, errorCode: String(err?.response?.status || '500') });
      alert('Upload failed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      {current && (
        <div style={{ background: '#fff', border: '1px solid var(--mist-300)', borderRadius: 12, padding: 12 }}>
          <div style={{ fontWeight: 600 }}>Current file</div>
          <div style={{ fontSize: 14 }}>{current.fileName} — {new Date(current.date).toLocaleString()}</div>
        </div>
      )}
      <div style={{ background: '#fff', border: '1px solid var(--mist-300)', borderRadius: 12, padding: 16 }}>
        <div style={{ display: 'grid', gap: 8 }}>
          <label>Jurisdiction<br/>
            <select value={jurisdiction} onChange={e=>setJurisdiction(e.target.value)} aria-label="Upload jurisdiction">
              <option value="ENGLAND_WALES">England & Wales</option>
              <option value="SCOTLAND">Scotland</option>
              <option value="NORTHERN_IRELAND">Northern Ireland</option>
            </select>
          </label>
          <label>Choose file (PDF, JPG, PNG, DOCX; max 20MB)
            <input type="file" accept=".pdf,.jpg,.jpeg,.png,.docx" onChange={e=>setFile(e.target.files?.[0] || null)} aria-label="Signed will file"/>
          </label>
          <button type="button" onClick={()=>submit(false)} disabled={!file || busy} style={{ padding: '10px 14px', border: 'none', borderRadius: 10, background: 'var(--sage-600)', color: '#fff', fontWeight: 700 }}>Upload</button>
        </div>
      </div>
      {confirmInfo && (
        <div role="dialog" aria-modal="true" style={{ background: 'rgba(0,0,0,0.4)', position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div style={{ background: '#fff', padding: 20, borderRadius: 12, minWidth: 320 }}>
            <div style={{ fontWeight: 700, marginBottom: 8 }}>Replace existing will?</div>
            <div style={{ fontSize: 14, color: '#333' }}>Existing file: {confirmInfo.fileName} — {new Date(confirmInfo.date).toLocaleString()}</div>
            <div style={{ display: 'flex', gap: 10, marginTop: 14, justifyContent: 'center', alignItems: 'center' }}>
              <button type="button" autoFocus onClick={()=>{ setConfirmInfo(null); submit(true); track('will_upload_replaced', { userId: currentUser?.id, oldFileName: confirmInfo.fileName }); }} style={{ padding: '8px 12px', borderRadius: 8, border: 'none', background: 'var(--sage-600)', color: '#fff', fontWeight: 600, boxShadow: 'var(--shadow-soft)' }}>Confirm Replace</button>
              <button type="button" onClick={()=>setConfirmInfo(null)} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid var(--mist-300)', background: '#fff', color: 'var(--dusk-800)' }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


